import type { ISwSettings } from "app/@types/ISwSettings";
import { PackageName } from "app/common/constants/packageNames";
import { isLocked, isOpen } from "app/common/services/pageClaims";

const LEGACY_PLATFORM_PLAN_NAMES = new Set<PackageName>([
    PackageName.Team,
    PackageName.StarterMonthly,
    PackageName.StarterAnnual,
    PackageName.ProfessionalMonthly,
    PackageName.ProfessionalAnnual,
]);

const isEnabledNavigationClaim = (mode: unknown): boolean => mode === true || mode === "True" || mode === "Open";

export const isPlatformFourOhUser = (swSettings: ISwSettings): boolean => {
    if (LEGACY_PLATFORM_PLAN_NAMES.has(swSettings.user?.plan as PackageName)) {
        return false;
    }

    const homeResources = swSettings.components.Home?.resources;
    const hasSelfServePackage = Boolean(
        homeResources?.IsNoTouchUser || homeResources?.IsTrial || homeResources?.IsAfterTrial,
    );
    const hasDigitalSuite =
        isOpen(swSettings.components.DigitalSuiteAcquisition) ||
        isLocked(swSettings.components.DigitalSuiteAcquisition);

    return (
        hasSelfServePackage ||
        hasDigitalSuite ||
        isEnabledNavigationClaim(swSettings.components.Solution2NewNavigation?.resources?.AvaliabilityMode) ||
        isEnabledNavigationClaim(swSettings.components.Solution2NewNavigationOptIn?.resources?.AvaliabilityMode)
    );
};
